import React, { useEffect } from "react";
import * as THREE from "three";
import Effects from "./Effects";

export function getPointLight(color, size) {
  var light = new THREE.PointLight(color, size);

  light.castShadow = true;

  return light;
}

export function getSpotLight(color, size) {
  var light = new THREE.SpotLight(color, size);

  light.castShadow = true;

  light.shadow.bias = 0.001; // for smoothing out the shadows where the objects meet the ground

  // the shadow map resolution by default is 1024 witch is low in our case
  // ! increasing the shadow map resolution too much could make performance issues
  light.shadow.mapSize.width = 2048;
  light.shadow.mapSize.height = 2048;

  return light;
}

export function getDirectionalLight(color, size) {
  var light = new THREE.DirectionalLight(color, size);

  light.castShadow = true;

  return light;
}

export function getAmbientLight(color, size) {
  var light = new THREE.AmbientLight(color, size);

  return light;
}

export function NeonLight({ color, size, position, intensity }) {
  return (
    <>
      <spotLight
        color={color}
        size={size}
        position={[...position]}
        intensity={intensity}
      />
    </>
  );
}
